import { EditableQuestion } from '../../components/Questionnaires/types';
import { ActionTypes } from './types';

export const setEditedQuestionId = (id: string | null) => ({
  type: ActionTypes.SET_EDITED_QUESTION_ID,
  payload: id
});

export const setQuestions = (questions: EditableQuestion[]) => ({
  type: ActionTypes.SET_QUESTIONS,
  payload: questions
});

export const setInitialQuestions = (questions: EditableQuestion[]) => ({
  type: ActionTypes.SET_INITIAL_QUESTIONS,
  payload: questions
});

export const addEmptyQuestion = () => ({
  type: ActionTypes.ADD_EMPTY_QUESTION
});

export const addEmptyQuestionToSection = (sectionNumber: number) => ({
  type: ActionTypes.ADD_EMPTY_QUESTION_TO_SECTION,
  payload: sectionNumber
});

export const setCurrentSection = (sectionNumber: number) => ({
  type: ActionTypes.SET_CURRENT_SECTION,
  payload: sectionNumber
});

export const setBlockingAnswers = (answers: string[]) => ({
  type: ActionTypes.SET_BLOCKING_ANSWERS,
  payload: answers
});

export const addBlockingAnswer = (answerId: string) => ({
  type: ActionTypes.ADD_BLOCKING_ANSWER,
  payload: answerId
});

export const removeBlockingAnswer = (answerId: string) => ({
  type: ActionTypes.REMOVE_BLOCKING_ANSWER,
  payload: answerId
});